var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseInput',{attrs:{"id":_vm.id,"type":"text","required":_vm.required,"title":_vm.title,"value":_vm.value,"label":_vm.label},on:{"input":_vm.emitInput}})}
var staticRenderFns = []

export { render, staticRenderFns }